import { Reveal } from "./Reveal";

const STRIPS = [
  ["01", "Listen first", "Understand your symptoms and goals."],
  ["02", "Explain clearly", "Make every next step easy to understand."],
  ["03", "Care together", "Choose a plan that feels right for you."],
];

export function ManifestoStrip() {
  return (
    <section className="care-strip">
      <div className="container">
        <Reveal><div className="section-label manifesto-label"><span className="chapter-no">03</span>The manifesto</div></Reveal>
        <div className="care-grid">
          {STRIPS.map(([num, title, text], i) => (
            <Reveal key={num} delay={i * 0.12}><div><span className="strip-number">{num}</span><b>{title}</b><p>{text}</p></div></Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
